module.exports = __webpack_public_path__ + "img/img12.4830bde9.png";